import React, { useState, useEffect } from "react";
import { injectModels } from "../../../redux/injectModels";
import { useParams, Link } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { TicketService } from "../../../services";
import { handleConsoleError } from "../../../utils/common-methods";

function UserTicketRedeem(props) {
  const { order } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const redeemEventTicket = async () => {
      props.application.setLoading(true);
      try {
        var data = { Id: order };
        const res = await TicketService.redeemTicket(data);
        if (res?.isSuccess && res?.data?.length > 0) {
          setData(res?.message);
          props.application.setLoading(false);
        } else {
          setData(res?.message);
          props.application.setLoading(false);
        }
      } catch (error) {
        const message = handleConsoleError(error);
        setError(error?.message || message);
        props.application.setLoading(false);
      }
    };

    redeemEventTicket();
  }, []); // Empty array means this effect runs once when the component mounts

  return (
    <React.Fragment>
      <section className="loginswallow-dashboard">
        <div
          style={{
            textAlign: "center",
            marginTop: "100px",
            minHeight: "300px",
          }}
        >
          <h1>Ticket Redeem Status</h1>
          {data && (
            <div>
              <p>
                <h4>{data}</h4>
              </p>
              <Link to={routes.DEFAULT}>Go to Home</Link>
            </div>
          )}
          {error && (
            <div>
              <p>{error} Please contact to admin</p>
              <Link to={routes.DEFAULT}>Go to Home</Link>
            </div>
          )}
        </div>
      </section>
    </React.Fragment>
  );
}
export default injectModels(["admin", "application"])(UserTicketRedeem);
